import loadable from '@loadable/component'

export const RACTable = loadable(() => import('./RACTable'))
export type {
  RACTableAnalystAddressProps,
  RACTableAnalystProps,
  IdentifierListProps,
  RACTableItemProps,
  RACTableProps
} from './RACTable'
